import { takeUntil, map, first } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PreferencesService } from './../services/preferences.service';
import { PreferenceAnnonceur, PreferenceAnnonceurEnum } from './../model/preference-annonceur';
import { Subject } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { PreferenceType } from './../../../shared/models/enum/preferenceType';
import { PreferenceMessages } from './../../../shared/models/component-messages/preference-messages';
import { LogService } from './../../../shared/services/log.service';
import { Component, OnInit } from '@angular/core';
import { Preference, Value } from '../model/preference';
import { InformationComponent } from '../../../shared/modals/information/information.component';
import { EnumMicroDroits } from '../../../administration/models/micro.droits';
import { AuthorizationService } from '../../../../authorization/services/authorization.service';

@Component({
  selector: 'app-preferences-compte-annonceur',
  templateUrl: './preferences-compte-annonceur.component.html',
  styleUrls: ['./preferences-compte-annonceur.component.scss']
})
export class PreferencesCompteAnnonceurComponent implements OnInit {

  private LOG: LogService = new LogService(PreferencesCompteAnnonceurComponent);

  public preferenceMessages = new PreferenceMessages();

  public typeAnnonceur = PreferenceType.ANNONCEUR;

  public form: FormGroup;

  private unsubscribe$ = new Subject<void>();

  preference: PreferenceAnnonceur = new PreferenceAnnonceur;

  idToUpdate: number = -1;
  updateMode: boolean = false;
  
  isGestionComptesAnnonceur: boolean;

  constructor(private preferencesService: PreferencesService, private modalService: NgbModal, private authorizationService: AuthorizationService) { }

  ngOnInit(): void {
    this.form = new FormGroup({});
    this.getAllList();
    this.habilitations();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  initForm() {
    this.form.get('preference_SepAtt_annonceur_SepAtt_identifiant')?.setValue(this.preference.identifiant);
    this.form.get('preference_SepAtt_annonceur_SepAtt_emailboamp')?.setValue(this.preference.emailBoamp);
  }

  getAllList() {
    this.preferencesService.getFullAnnonceur()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (data) => {
          if (data.length > 0) {
            this.updateMode = true;
            this.idToUpdate = data[0].id;
            for (let value in data[0].content.values) {
              switch (data[0].content.values[value].code) {
                case PreferenceAnnonceurEnum.IDENTIFIANT:
                  this.preference.identifiant = data[0].content.values[value].value;
                  break;
                case PreferenceAnnonceurEnum.EMAILBOAMP:
                  this.preference.emailBoamp = data[0].content.values[value].value;
                  break;

                default:
                  break;
              }
            }
            this.preference.id = data[0].id;
          } else {
            this.updateMode = false;
            this.idToUpdate = -1;
          }
          this.initForm();
        }
      });
  }

  savePref(): void {
    let preference = new Preference;

    let v1 = new Value;
    v1.code = PreferenceAnnonceurEnum.IDENTIFIANT
    v1.value = this.form.get('preference_SepAtt_annonceur_SepAtt_identifiant')?.value;
    preference.content.values.push(v1);

    let v3 = new Value;
    v3.code = PreferenceAnnonceurEnum.EMAILBOAMP
    v3.value = this.form.get('preference_SepAtt_annonceur_SepAtt_emailboamp')?.value;
    preference.content.values.push(v3);


    if (!this.updateMode && this.idToUpdate === -1) {
      const modalRef = this.modalService.open(InformationComponent);
      modalRef.componentInstance.title = '';
      modalRef.componentInstance.content = this.preferenceMessages.modal_create_text;
      modalRef.componentInstance.OkOuRetour = true;
      modalRef.dismissed.pipe(map((reason: boolean) => {
        return reason;
      }))
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: ((reason) => {
            if (reason) {
              this.preferencesService.createAnnonceur(preference)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                  next: ((data) => {
                    this.annuler();
                    this.getAllList();
                  })
                });
            }
          })
        })
    } else {
      preference.id = this.idToUpdate;
      const modalRef = this.modalService.open(InformationComponent);
      modalRef.componentInstance.title = '';
      modalRef.componentInstance.content = this.preferenceMessages.modal_update_text;
      modalRef.componentInstance.OkOuRetour = true;
      modalRef.dismissed.pipe(map((reason: boolean) => {
        return reason;
      }))
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: ((reason) => {
            if (reason) {
              this.preferencesService.updateAnnonceur(preference)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                  next: ((data) => {
                    this.annuler()
                    this.getAllList();
                  })
                });
            }
          })
        })
    }
  }

  annuler(): void {
    if (!this.updateMode) {
      this.form.reset();
    } else {
      this.initForm();
    }
  }

  private habilitations() {
    this.authorizationService.hasAnyMicroRightIn([EnumMicroDroits.COMPTES_ANNONCEURS_GESTION])
      .pipe(first())
      .subscribe(isGestionComptesAnnonceur => { this.isGestionComptesAnnonceur = isGestionComptesAnnonceur });
  }


}
